import { urlFormatter } from "sb-resp-utils";
export var mapLeagueUrl = function (ajustPath, league) {
    var urlParams = urlFormatter.getSportUrl(league.sportName) + "/" + urlFormatter.getLeagueUrl(league.name);
    league.linkUrl = ajustPath(urlParams);
    return league;
};
//# sourceMappingURL=mapLeagueUrl.js.map